export default __webpack_public_path__ + "static/media/img11.c685dd1e.png";